import AUX from "../../../hoc/Aux_";
import React, { Component } from "react";
import $ from "jquery";
import _ from "lodash";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { Spinner } from "reactstrap";
import axios from "../../Shared/auth-header";
import { connect } from "react-redux";
import mailGunEmailActions from "../../../store/mailgunEmails/action";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

class MG_Add_FacilityReps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      availablePositions: [],
      selectedPositions: [],
      loading: false,
    };
  }

  handleClose = () => {
    this.setState({ availablePositions: [], selectedPositions: [] });
    this.props.handleClose();
  };

  onShow = async () => {
    const { entityKey } = this.props;
    if (!entityKey) {
      toast.error("Area information not available.");
      return;
    }
    this.setState({ loading: true });
    try {
      const response = await axios.get(
        `/api/FacilityRepresentatives/ByArea/${entityKey}`
      );
      if (response.data && response.data.status === "Success") {
        const positions = response.data.data || [];
        // Filter out positions already added
        const existingPositionIds = (
          this.props.melstate.additionalRecipientsFacilityReps || []
        ).map((r) => r.positionId);
        const available = positions.filter(
          (p) => !existingPositionIds.includes(p.positionId)
        );
        this.setState({ availablePositions: available, selectedPositions: [] });
      } else {
        toast.error((response.data && response.data.message) || "Failed to load facility representatives.");
      }
    } catch (err) {
      toast.error("Error loading facility representatives.");
    }
    this.setState({ loading: false });
  };

  handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      this.setState((prev) => ({
        selectedPositions: [...prev.selectedPositions, row],
      }));
    } else {
      this.setState((prev) => ({
        selectedPositions: prev.selectedPositions.filter(
          (p) => p.positionId !== row.positionId
        ),
      }));
    }
  };

  handleOnSelectAll = (isSelect, rows) => {
    if (isSelect) {
      this.setState({ selectedPositions: rows });
    } else {
      this.setState({ selectedPositions: [] });
    }
  };

  handleSubmit = () => {
    const { selectedPositions } = this.state;
    if (selectedPositions.length === 0) {
      toast.warn("Please select at least one position.");
      return;
    }

    const { emailListId } = this.props.melstate;
    const newReps = selectedPositions.map((p) => ({
      id: 0,
      positionId: p.positionId,
      positionName: p.positionName,
      memberId: p.memberId,
      memberName: p.memberName,
      email: p.email,
      afrt_email_list_id: emailListId,
      isactive: true,
      isblocked: false,
    }));

    this.props.addFacilityReps(newReps);
    this.handleClose();
  };

  render() {
    const { availablePositions, selectedPositions, loading } = this.state;

    const columns = [
      {
        dataField: "positionId",
        text: "Position ID",
        hidden: true,
      },
      {
        dataField: "positionName",
        text: "Position",
        sort: true,
      },
      {
        dataField: "memberName",
        text: "Current Member",
        sort: true,
      },
      {
        dataField: "email",
        text: "Email",
        sort: true,
      },
    ];

    const selectRow = {
      mode: "checkbox",
      clickToSelect: true,
      selected: selectedPositions.map((p) => p.positionId),
      onSelect: this.handleOnSelect,
      onSelectAll: this.handleOnSelectAll,
    };

    return (
      <AUX>
        <Modal
          className="EmailMOdal latest"
          show={this.props.showModal}
          onHide={this.handleClose}
          size="lg"
          centered
          onShow={this.onShow}
        >
          <Modal.Header className="modal-header bg-secondary py-2" closeButton>
            <Modal.Title>
              <h5 className="modal-title text-white mt-0">
                Add Facility Representatives
              </h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container-fluid">
              {loading ? (
                <div className="d-flex justify-content-center p-4">
                  <Spinner />
                </div>
              ) : availablePositions.length === 0 ? (
                <div className="text-center p-3">
                  <p>No available facility representative positions to add.</p>
                </div>
              ) : (
                <ToolkitProvider
                  keyField="positionId"
                  data={availablePositions}
                  columns={columns}
                >
                  {(props) => (
                    <BootstrapTable
                      keyField="positionId"
                      selectRow={selectRow}
                      {...props.baseProps}
                    />
                  )}
                </ToolkitProvider>
              )}
            </div>
            <div className="row mt-3">
              <div className="col-12 text-centered d-flex justify-content-center">
                <button
                  className="btn btn-sm btn-danger w-md waves-effect waves-light"
                  type="button"
                  onClick={this.handleClose}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-success btn-sm ml-2 w-md waves-effect waves-light"
                  type="button"
                  onClick={this.handleSubmit}
                  disabled={selectedPositions.length === 0}
                >
                  Add Selected Representatives
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </AUX>
    );
  }
}

export default connect(
  (state) => ({
    melstate: state.mailGunEmail,
  }),
  {
    ...mailGunEmailActions,
  }
)(MG_Add_FacilityReps);
